var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSilverRank1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "silver_rank_1_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 22,
    width: 179,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.787 22H11v154h178.787V22z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#silver_rank_1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.624 26.198c-4.287-5.8-13.03-5.538-17.01.478-10.381 15.714-10.447 36.857 1.397 52.892 14.78 20.01 42.657 24.7 63.133 10.973l-47.52-64.343z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.328 60.067c-6.672-2.747-14.02 2-14.295 9.2-.721 18.809 10.199 36.923 28.656 44.522 23.033 9.476 49.31-.922 59.698-23.248L61.542 74.964 25.335 60.067h-.007z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.474 26.198c4.287-5.8 13.03-5.538 17.009.478 10.382 15.714 10.448 36.857-1.396 52.892-14.781 20.01-42.657 24.7-63.133 10.973l47.52-64.343z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.459 60.067c6.679-2.747 14.02 2 14.295 9.2.721 18.809-10.199 36.923-28.656 44.522-23.033 9.476-49.31-.922-59.699-23.248l37.846-15.577 36.207-14.897h.007z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.743 28.814h100.873c6.03 0 10.927 4.886 10.927 10.902v75.061c0 33.79-27.497 61.223-61.364 61.223-33.866 0-61.363-27.433-61.363-61.223V39.716c0-6.017 4.897-10.902 10.927-10.902z",
    fill: "#CDCBCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.034 54.305h70.291c4.201 0 7.609 3.4 7.609 7.593v45.947c0 23.542-19.158 42.664-42.761 42.664-23.596 0-42.761-19.116-42.761-42.664v-45.94c0-4.193 3.408-7.593 7.61-7.593l.012-.007z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.331 56.921c2.753 0 4.988 2.237 4.988 4.977v45.947c0 22.084-18.005 40.048-40.14 40.048-22.134 0-40.133-17.964-40.133-40.048v-45.94c0-2.747 2.242-4.977 4.988-4.977h70.291m0-2.616h-70.29c-4.202 0-7.61 3.4-7.61 7.592v45.947c0 23.562 19.145 42.664 42.754 42.664 23.61 0 42.762-19.102 42.762-42.664V61.904c0-4.191-3.408-7.592-7.61-7.592h-.006z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.255 28.814L40.823 61.18v48.026l80.568-80.39H73.255zM97.342 95.936l63.513-63.368a10.91 10.91 0 00-8.239-3.753h-15.278L83.702 82.328l13.64 13.608z",
    fill: "#fff",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRank1);
export default ForwardRef;